<template>
  <AnablueSidebar
    :items="sidebarTabs"
    :minimize="minimize"
    @update:minimize="setMinimize"
    :translations="translationsObject"
  />
</template>

<script>
  import getSidebarTabs from './_nav'
  import {ActiveUser} from '@/services/user';
  import {translationsObject} from "@/constants/translations";


  export default {
    name: 'TheSidebar',
    data() {
      return {
        translationsObject,
        sidebarTabs: [],
        userData: null,
      }
    },
    computed: {
      minimize() {
        return this.$store.state.sidebarMinimize
      }
    },
    props: {
      selectedId: {
        required: false,
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler() {
          if (!this.$route.params.campaignId) {
            this.$store.commit("set", ["memberId", null])
          }
          this.getRoutesForSidebar()
        }
      },
      $route: {
        immediate: true,
        handler() {
          if (!this.$route.params.coveryearId) {
            this.$store.commit("set", ["memberId", null])
          }
          this.getRoutesForSidebar()
        }
      },
      selectedId: {
        handler: function (newV, oldV) {
          if (newV) {
            this.getRoutesForSidebar()
          }
        }
      },
      "$store.state.memberId"() {
        this.getRoutesForSidebar()
      }
    },
    mounted() {
      this.getRoutesForSidebar()
    },
    methods: {
      setMinimize(value) {
        this.$store.commit('set', ['sidebarMinimize', value]);
      },

      getSelectedMemberId() {
        const selected_id = this.$route.params.id || this.$store.state.memberId;
        if (selected_id) return selected_id
        return
      },

      async getRoutesForSidebar() {
        this.userData = ActiveUser.get();
        this.sidebarTabs = getSidebarTabs(
          this.userData,
          this.$route.params.campaignId,
          this.$route.params.fileId,
          this.$route.params.coveryearId,
          this.getSelectedMemberId(),
        );
      },
    },
  }
</script>
